module.exports = __webpack_public_path__ + "afissore.jpg?0077974816b22a8bd75055efe53ea378";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/afissore.jpg
// module id = 98
// module chunks = 0